<template>
  <div class="max-w-screen-2xl mx-auto px-4 md:px-10">
    <div class="bg-white rounded-xl px-8 md:px-16 py-12 font-light">
      <diamond-detail-carat-content
        :carat="carat"
        :form="form"
        :width="width"
        :length="length"
      >
        <template #title>
          <base-headline class="!text-2xl mb-6 !normal-case !tracking-normal">
            {{ t("components.diamonds.details.carat.title") }}:
            {{ $n(carat) }} ct.
          </base-headline>
        </template>
      </diamond-detail-carat-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailCaratContent from "@/components/diamonds/details/DiamondDetailCaratContent.vue";

const { t } = useI18n();

defineProps<{
  carat: number;
  form: string;
  width: number;
  length: number;
}>();
</script>

<style scoped></style>
